import React from "react"
import { graphql, StaticQuery } from "gatsby"
import { Link } from "gatsby"
import Tilt from 'react-vanilla-tilt'

import Layout from "../components/layout"
import SEO from "../components/seo"
import TeamCard from "../components/teamCard"
import AreasSection from "../components/areas"
import ContactSection from "../components/contactCard"

import "../utils/normalize.css"
import "../utils/css/screen.css"
import "../utils/css/components/areas.css"

import logo from "../../content/assets/logo.png"
import bird from "../../content/assets/albatross_bird_large.png"
import arrow from "../../content/assets/arrow-right.svg"

import value1 from "../../content/assets/values_1.svg"
import value2 from "../../content/assets/values_2.svg"
import value3 from "../../content/assets/values_3.svg"
import value4 from "../../content/assets/values_4.svg"

import teamImg from "../../content/assets/team_img.jpg"
import teamNachiket from "../../content/assets/team/team_nachiket.jpg"
import teamParesh from "../../content/assets/team/team_paresh.jpg"
import teamParag from "../../content/assets/team/team_parag.jpeg"
import teamSiddharth from "../../content/assets/team/team_siddharth.jpg"
import teamYogesh from "../../content/assets/team/team_yogesh.jpeg"


const AboutPage = ({ data }, location) => {
    const siteTitle = data.site.siteMetadata.title
    const projects = data.allStrapiPortfoliolinks.edges

    return (
        <Layout title={siteTitle}>
            <SEO
                title="Studio Albatross - multi-disciplinary creative agency | Marketing | Films | Design"
                keywords={[`brand design`, `brand strategy`, `digital marketing`, `marketing consulting`, `marketing communication`, `social media marketing`, `visual design`, `interaction design`, `UI/UX design`, `User Experience`, `User Interface`, `corporate films`, `2D/3D animation`, `product videos`, `ad films`, `documentaries`, `best digital marketing agency`]}
                description="Studio Albatross is a multi-disciplinary creative agency that works with global innovative startups to significant conglomerates to tell their stories through our three wings - marketing, films & design."
            />
            <section className="about-page">
                <Link className="site-head-logo" to={`/`}>
                    <img src={logo} alt="Logo" />
                </Link>
                <div className="mid section-description">
                    <img src={bird} alt="Albatross Bird" />

                    <div className="section-title">
                        Why Albatross?
                </div>
                    <p className=" section-description-focus">The wandering albatross is probably the most magnificent of the sea birds. It's majestic to say the least. With the largest wingspan among the existing birds, it can get as long as 12 feet.  It soars above the bustling waves of the deep blue and covers tens of thousands of miles a month. It is highly social and highly ambitious with its wandering endeavours. </p>
                </div>
            </section>

            <section className="section-values">
                <div className="section-title">
                    Values and Beliefs
                </div>
                <div className="values-container">
                    <div className="value">
                        <img src={value1} alt="Value" />
                        <div>For the Greater Good</div>
                        <p>What if you like it… but your client doesn’t?! Perception of art is subjective but art in itself is a science! Let's work together to capture 'their' attention... that’s the ultimate goal... the “greater good”.</p>
                    </div>
                    <div className="value">
                        <img src={value2} alt="Value" />
                        <div>Rome wasn’t built in a day!</div>
                        <p>You either get it ‘immediately’ or you get it ‘good’. Quality is what we strive for. The process is natural.. Like the harvest. It takes its own time to achieve it.</p>
                    </div>
                    <div className="value">
                        <img src={value3} alt="Value" />
                        <div>Thousand hackings at the leaves, one striking at the root</div>
                        <p>Dive deep, find the root, smell the soul…. And out of there, everything flows. Every business is unique and needs to be treated uniquely. We believe in “Inside Out”.</p>
                    </div>
                    <div className="value">
                        <img src={value4} alt="Value" />
                        <div>Whole is greater than the sum of its parts</div>
                        <p>“You or me?” - the question is void and null! It’s “You and Me”. Everyone brings his/her unique voice to the table. Together we march towards the sunshine. The good old “Teamwork”!</p>
                    </div>
                </div>
            </section>
            <section className="section-team">
                <div className="section-title">
                    The Albatrossers
                </div>
                <div className="team-container">
                        <div className="team-member">
                            <TeamCard
                                name='Nachiket Dhavalikar'
                                thumbnail={teamNachiket}
                                position='Founder & CEO'
                                description='Storyteller, Filmmaker, World Cinema Geek, Chelsea FC maniac, Test Cricket devotee, avid reader, champion at "Incessant talking"..!!'
                            />
                        </div>
                        <div className="team-member">
                            <TeamCard
                                name='Parag Dharmadhikari'
                                thumbnail={teamParag}
                                position='Advisor - Albatross Marketing Solutions'
                                description='Marketer to the core, Traveller, Trekker, Foodie, Perennially hungry!'
                            />
                        </div>
                        <div className="team-member">
                            <TeamCard
                                name='Paresh Deshpande'
                                thumbnail={teamParesh}
                                position='Head of Albatross Designs'
                                description="Lives Design, Loves Movies, Google fanboy, Pop Culture aficionado, only Indian who doesn't know the count of Sachin Tendulkar centuries!"
                            />
                        </div>
                        <div className="team-member">
                            <TeamCard
                                name='Yogesh Jadhav'
                                thumbnail={teamYogesh}
                                position='Project Manager, Film Director'
                                description='Filmmaker, Fitness Enthusiast, Gym instructor, Cricket lover, teetotaler, voracious eater!'
                            />
                        </div>
                        <div className="team-member">
                            <TeamCard
                                name='Siddharth Joshi'
                                thumbnail={teamSiddharth}
                                position='Head of Albatross Events, Production Manager'
                                description='Trucker, Badminton Enthusiast, Plays every sport, Highly skilled long distance driver, Manager by "absence"!'
                            />
                        </div>
                </div>
            </section>
            <ContactSection></ContactSection>
        </Layout>
    )
}

const indexQuery = graphql`
query {
    site {
        siteMetadata {
          title
        }
      }
    allStrapiPortfoliolinks(filter: {featured: {eq: true}, categories: {elemMatch: {name: {in: "Films"}}}}, limit: 3) {
      edges {
        node {
          id
          link
          title
          enabled
          featured
          thumbnail {
            childImageSharp {
              fluid(maxWidth: 400, maxHeight: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          categories {
            name
          }
        }
      }
    }
  }
`

export default props => (
    <StaticQuery
        query={indexQuery}
        render={data => (
            <AboutPage location={props.location} data={data} {...props} />
        )}
    />
)
